import TchrURL from "../../TchrURL";
import { useStytchUser, useStytchSession, useStytch } from "@stytch/react";

export interface CheckoutOptions {
  yearly?: boolean;
  promotionCode?: string;
  enabled: boolean;
}

export const useCheckoutParams = () => {
  const { user } = useStytchUser();
  const { session } = useStytchSession();
  const stytch = useStytch();

  const buildCheckoutUrl = (pathname: string, options?: CheckoutOptions) => {
    const searchParams = new URLSearchParams();

    // Add customer email if available
    if (session && user?.emails.length) {
      searchParams.append("customer_email", user.emails[0].email);
    }

    searchParams.append("returnTo", pathname);

    // Add yearly parameter if specified
    if (options?.yearly) {
      searchParams.append("yearly", "true");
    }

    // Add promotion code if specified
    if (options?.promotionCode) {
      searchParams.append("coupon", options.promotionCode);
    }

    // Add unauthenticated flag for guest checkouts
    if (!session) {
      searchParams.append("unauthenticated", "true");
    }

    const url = new TchrURL("payment/checkout");
    url.search = searchParams.toString();
    return url;
  };

  const buildHeaders = (): HeadersInit => {
    const headers: HeadersInit = {
      Referrer: window.location.href,
    };

    // Add auth header only if user is authenticated
    if (session) {
      const tokens = stytch.session.getTokens();
      if (tokens?.session_jwt) {
        headers.Authorization = `Bearer ${tokens.session_jwt}`;
      }
    }

    return headers;
  };

  return {
    buildCheckoutUrl,
    buildHeaders,
    session,
    user
  };
};
